import { useQuery } from '@tanstack/react-query';
import { Speciality } from 'src/models';
import { api } from 'src/services/api';

export type UseGetSpecialityListParams = {};

export type GetSpecialityListResponse = {
  specialties: Pick<
    Speciality,
    'specialty_id' | 'specialty_name' | 'is_public'
  >[];
};

type UseGetSpecialityListOptions = {
  enabled?: boolean;
};

export const useGetSpecialityList = (
  params?: UseGetSpecialityListParams,
  options?: UseGetSpecialityListOptions
) => {
  return useQuery({
    ...options,
    queryKey: ['specialtyList', params],
    queryFn: () =>
      api
        .get<GetSpecialityListResponse>('/specialties')
        .then(({ data }) => data),
  });
};
